export default class FoldContent {
  constructor() {
    this.foldItems = document.querySelectorAll('.fold-content');

    this.init();
  }

  init() {
    this.foldItems.forEach((item) => {
      item
        .querySelector('.fold-content__header')
        .addEventListener('click', (e) => this.handleToggle(e));

      //if oen class present open item
      if (item.classList.contains('open')) {
        const wrapper = item.querySelector('.fold-content__content-wrapper');
        wrapper.style.maxHeight = `${wrapper.scrollHeight}px`;
      }
    });
  }

  handleToggle(e) {
    e.preventDefault();
    const parent = e.currentTarget.parentElement;

    const toggleGroup = parent.getAttribute('data-toggleGroup');

    if (toggleGroup) {
      this.foldItems.forEach((item) => {
        if (item.getAttribute('data-toggleGroup') === toggleGroup) {
          const wrapper = item.querySelector('.fold-content__content-wrapper');
          if (wrapper) {
            if (item !== parent) {
              //is same toggle group so close item
              item.classList.remove('open');
              wrapper.style.maxHeight = null;
            }
          }
        }
      });
    }

    const myWrapper = parent.querySelector('.fold-content__content-wrapper');
    if (toggleGroup) {
      //toggle self
      parent.classList.add('open');
    } else {
      //toggle self
      parent.classList.toggle('open');
    }

    if (myWrapper.style.maxHeight && !toggleGroup) {
      myWrapper.style.maxHeight = null;
    } else {
      myWrapper.style.maxHeight = `${myWrapper.scrollHeight}px`;
    }
  }
}
